import { render } from "./AlzataModalLayout.vue?vue&type=template&id=e3e7c456"
import script from "./AlzataModalLayout.vue?vue&type=script&lang=js"
export * from "./AlzataModalLayout.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__